import { STATUS_CODE } from '@kc-console/core';

import { checkClassicBucketGuard } from './checkClassicBucketGuard';

import type { ServiceAppState } from '@kc-console/context';
import type { Guard } from '../../../types';

/**
 * Object Storage 서버사이드 초기 진입 시 classic 버킷 여부를 체크해 리다이렉트하는 가드.
 * @description
 * - 초기 진입 시점의 state 에 token / region 이 존재하므로 그대로 사용
 */
export const checkClassicBucketInitialGuard: Guard<ServiceAppState> = async ({
  state,
  context,
  queryClient,
}) => {
  const { status, token, region, language } = state;

  if (status !== STATUS_CODE.OK) return { status };

  return await checkClassicBucketGuard({
    context,
    queryClient,
    region,
    token,
    language,
  });
};

checkClassicBucketInitialGuard.displayName = 'checkClassicBucketInitialGuard';
